import {DefinedFormFieldElement} from "@web-libs/core/forms/ui/fields/shared/form-field.types";

export type FormLayoutFieldProps = {
    field: DefinedFormFieldElement
    index: number
}

export const FormLayoutField = (props: FormLayoutFieldProps) => {
    const fieldStyles = {
        marginLeft: props.index !== 0 ? 16:0,
        flexGrow:1
    }

    return (
        <div style={fieldStyles}>{props.field}</div>
    )
}
